import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CommonBookingComponentsModule } from '@fcom/common-booking/components';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { OrderApiModule } from '@fcom/dapi/api/order-api.module';

import { AncillaryPurchaseCheckoutRouteComponent } from './routes/ancillary-purchase-checkout-route.component';
import { AncillaryPurchaseCheckoutGuard } from './services/ancillary-purchase-checkout.guard';

@NgModule({
  imports: [CommonModule, PipesModule, ComponentsModule, OrderApiModule, CommonBookingComponentsModule],
  exports: [AncillaryPurchaseCheckoutRouteComponent],
  declarations: [AncillaryPurchaseCheckoutRouteComponent],
  providers: [AncillaryPurchaseCheckoutGuard],
})
export class AncillaryPurchaseCheckoutModule {}
